export const PROHIBITED_ITEMS_REPORT_GRID_LOADING =
  'PROHIBITED_ITEMS_REPORT_GRID_LOADING';
export const PROHIBITED_ITEMS_REPORT_GET_STUDENTS =
  'PROHIBITED_ITEMS_REPORT_GET_STUDENTS';
export const PROHIBITED_ITEMS_REPORT_GRID_ERROR =
  'PROHIBITED_ITEMS_REPORT_GRID_ERROR';
export const PROHIBITED_ITEMS_REPORT_TOGGLE_STUDENT_CHECKED =
  'PROHIBITED_ITEMS_REPORT_TOGGLE_STUDENT_CHECKED';
export const PROHIBITED_ITEMS_REPORT_TOGGLE_CHECK_ALL =
  'PROHIBITED_ITEMS_REPORT_TOGGLE_CHECK_ALL';



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/page/types.js